/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc. All Rights Reserved.
 *
 * @file questionTopicsModalUtils.js
 */

/**
 * Updates the selected topic on modal data shaped as { view, questionsByTopicPageId }.
 */
export function selectQuestionTopicsModalTopic(modal, selectedPageId) {
  if (!modal?.view) {
    return null;
  }

  return {
    ...modal,
    view: {
      ...modal.view,
      selectedPageId,
      questions: modal.questionsByTopicPageId?.[selectedPageId] || []
    }
  };
}

/**
 * Returns the first topic pageId that has questions.
 */
export function getDefaultQuestionTopicsPageId(chapters = []) {
  for (let i = 0; i < chapters.length; i += 1) {
    const topic = (chapters[i].topics || []).find((item) => item.questionCount > 0);

    if (topic?.pageId) {
      return topic.pageId;
    }
  }

  return chapters[0]?.topics?.[0]?.pageId || null;
}
